import React, { useState } from 'react';
import FeatherIcon from 'feather-icons-react';

import { Button } from '../../../../../components/buttons/buttons';
import { Modal } from 'antd';
import { Form } from '../ContactForm';

interface ITableButtonEditProps {
  segmentId: string;
  refetch: () => void;
  data: IFetchProps;
}

interface IFetchProps {
  name: string;
}

export function TableButtonEdit({ segmentId, refetch, data }: ITableButtonEditProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button className="btn-icon" type="info" onClick={() => setModalIsOpen(true)} to="#" shape="circle">
        <FeatherIcon icon="edit" size={16} />
      </Button>

      <Modal
        title="Editar plano"
        visible={modalIsOpen}
        onCancel={() => setModalIsOpen(false)}
        confirmLoading={true}
        footer={null}
        maskClosable={false}
        width={600}
        style={{ marginTop: -60 }}
        bodyStyle={{ padding: 0 }}
      >
        <Form
          formType="put"
          segmentId={segmentId}
          initialFields={{
            name: data.name,
          }}
          setModalIsOpen={setModalIsOpen}
          refetch={refetch}
        />
      </Modal>
    </>
  );
}
